import { render, staticRenderFns } from "./StepByStepNavigation.vue?vue&type=template&id=2aff6134"
import script from "./StepByStepNavigation.vue?vue&type=script&lang=js"
export * from "./StepByStepNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports